"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author JMr
 * @author Jan Prokop
 */


var AICleaningInfo =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(AICleaningInfo, _DomainObject_1$Domai);

  function AICleaningInfo(id, date, userId) {
    var _this;

    _classCallCheck(this, AICleaningInfo);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AICleaningInfo).call(this));
    _this.id = id;
    _this.date = date;
    _this.userId = userId;
    return _this;
  }

  return AICleaningInfo;
}(DomainObject_1.DomainObject);

exports.AICleaningInfo = AICleaningInfo;